<script lang="ts" setup>
import { TOCCO_EVENT_ENVIRONMENTS, TOCCO_EVENT_FILTER_ALL } from '~/api/drupal'
import type { Option } from '~/components/atoms/forms/select/Select.vue'

withDefaults(
  defineProps<{
    uid: string
    categoryOptions: Option[]
    targetGroupOptions: Option[]
    showEnvironment?: boolean
  }>(),
  {
    showEnvironment: true,
  },
)

const category = defineModel<string>('category', { default: TOCCO_EVENT_FILTER_ALL })
const targetGroup = defineModel<string>('targetGroup', { default: TOCCO_EVENT_FILTER_ALL })
const environment = defineModel<string[]>('environment', { default: () => [...TOCCO_EVENT_ENVIRONMENTS] })

const { t } = useI18n()

const allOption = { value: TOCCO_EVENT_FILTER_ALL, label: t('tocco.eventList.filters.all') }

const environmentOptions = [
  { value: TOCCO_EVENT_ENVIRONMENTS[0] ?? '', label: t('tocco.list.filters.environmentPhysical') },
  { value: TOCCO_EVENT_ENVIRONMENTS[1] ?? '', label: t('tocco.list.filters.environmentOnline') },
  { value: TOCCO_EVENT_ENVIRONMENTS[2] ?? '', label: t('tocco.list.filters.environmentELearning') },
]
</script>

<template>
  <div v-animate="{ animation: 'vertical-reveal' }" class="tocco-event-filters">
    <div class="dropdowns">
      <Select
        :id="`tocco-event-category-${uid}`"
        v-model="category"
        :name="`tocco-event-category-${uid}`"
        :label="t('tocco.eventList.filters.category')"
        :options="[allOption, ...categoryOptions]"
        :required="false"
      />
      <Select
        :id="`tocco-event-target-group-${uid}`"
        v-model="targetGroup"
        :name="`tocco-event-target-group-${uid}`"
        :label="t('tocco.eventList.filters.targetGroup')"
        :options="[allOption, ...targetGroupOptions]"
        :required="false"
      />
    </div>
    <Checkbox
      v-if="showEnvironment"
      :id="`tocco-event-environment-${uid}`"
      v-model="environment"
      :name="`tocco-event-environment-${uid}`"
      class="filter-checkbox"
      :options="environmentOptions"
      :required="false"
    />
  </div>
</template>

<style lang="scss" scoped>
.tocco-event-filters {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 40px;
}

.dropdowns {
  display: grid;
  grid-template-columns: 100%;
  gap: var(--gap);

  @include breakpoint(tl) {
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
}

:deep(.filter-checkbox .formkit-options) {
  flex-direction: row;
  gap: 32px;

  @include breakpoint(ts down) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--gap);
  }
}
</style>
